import {Record} from "immutable";
import {
    onAppLoad, onAppLoadFail,
    onAppLoadSuccess,
    onAppSetDetails,
    onAppSetMain,
    onAppSetSplash,
    onAppSubmit,
    onAppSubmitFail,
    onAppSubmitSuccess
} from "./actions";

const app = new Record({
    loading: false,
    details: {
        name: '',
        subtitle: '',
        details: '',
        icon: null
    },
    splash: {
        header: '',
        body: '',
        backgroundImage: null,
        headerFont: null,
        bodyFont: null,
        backgroundColor: '#ffffff',
        textColor: '#000000',
    },
    main: {
        headerFont: '',
        bodyFont: '',
        backgroundColor: '#F1F2F1',
        contentColor: '#000000',
        iconsColor: '#FCE1B6',
        buttonColor: '#FCE1B6',
        cardColor: '#ffffff',
    }
})();

export default (state = app, action) => {
    switch (action.type) {
        case onAppSetDetails().type:
            return state.setIn(['details', action.attr], action.value)
        case onAppSetSplash().type:
            return state.setIn(['splash', action.attr], action.value)
        case onAppSetMain().type:
            return state.setIn(['main', action.attr], action.value)

        case onAppSubmit().type:
            return state.set('loading', true)

        case onAppSubmitSuccess().type:
            return state.set('loading', false)

        case onAppSubmitFail().type:
            return state.set('loading', false)

        case onAppLoad().type:
            return state.set('loading', true)
        case onAppLoadFail().type:
            return state.set('loading', false)

        case onAppLoadSuccess().type:
            return state.set('details', action.response.details)
                .set('main', action.response.main)
                .set('splash', action.response.splash)
                .set('loading', false)

        default:
            return state;
    }
}
